import { DateTime } from 'luxon';

export interface UserTarget {
    id?: string | null;
    date: string | Date;
    amount: number;
}

export function createUserTarget(year: number, month: number): UserTarget {
    const date = DateTime.fromISO(`${year}-${month.toString().padStart(2, '0')}-01`, { zone: 'UTC' });

    return {
        date: date.toJSDate(),
        amount: 0,
    };
}
